var exports = {
  "kL": "xa15a2ab7--a0c78a--container",
  "UU": "xa15a2ab7--a0c78a--name",
  "z": "xa15a2ab7--a0c78a--full_width",
  "et": "xa15a2ab7--a0c78a--transport",
  "gO": "xa15a2ab7--a0c78a--ellipsis",
};

module.exports = exports;
